import { has } from 'ramda'
import { get } from './config'
import { IRegistrationSubmission } from '../App'

interface IRegistrationApiPayload {
    email: string
    user_metadata: {
        centre_id: string
        name: string
        subscription_opt_in: boolean
        locale: string
        source: string
        address: {
            country_code: string
            postcode?: string
            city?: string
        }
    }
}

const registerUser = (payload: IRegistrationSubmission): Promise<any> => {
    return fetch(`${get('registrationApiUrl')}/registration`, {
        headers: {
          Authorization:`Bearer ${payload.recaptchaValue}`
        },
        method: 'POST',
        body: JSON.stringify(transformPayload(payload))
    }).then(response => response.json())
}

const transformPayload = (payload: IRegistrationSubmission): IRegistrationApiPayload => {
    const result: IRegistrationApiPayload = {
        email: payload.email,
        user_metadata: {
            centre_id: get('centreId'),
            name: payload.fullname,
            subscription_opt_in: payload.subscription_opt_in,
            locale: payload.locale,
            source: payload.source,
            address: {
                country_code: payload.countryCode
            }
        }
    }

    const optionalAddressFields: string[] = ['city', 'postcode']

    optionalAddressFields.map((optionalAddressField: string) => {
        if (has(optionalAddressField)(payload)) {
            result.user_metadata.address[optionalAddressField] = payload[optionalAddressField]
        }
    })

    return result
}

export { IRegistrationApiPayload, registerUser, transformPayload }



// WEBPACK FOOTER //
// ./src/lib/register.tsx